import React from "react";
import Project from "./Project/Project";
import "./Projects.css";
import Portfolio from "../assets/Portfolio.png";
import LiveChat from "../assets/liveChat.png";
import Mantra from "../assets/Mantra.png";
import Drim from '../assets/Drim.png'
import GoogleMeet from '../assets/GoogleMeet.png'

const Projects = () =>
{
  return (
    <div className="projects">
      <h1>Projects</h1>
      <div className="projectComponent">
        <Project
          title={"1. Developer Portfolio."}
          text={"Personal Portfolio."}
          image={Portfolio}
          description={"Developer portfolio build using ReactJs with reusable components."}
          tech1={"ReactJs"}
          tech2={"HTML5"}
          tech3={"CSS3"}
          link="/"
        />
        <Project
          title={"2. Live chat web appilcation."}
          text={"Personal Portfolio."}
          image={LiveChat}
          link="https://livechatwebapp.vercel.app"
          description={"MERN Stack web application that support live chats and room chats, with features like create chat room, add users, remove users and group admin functionality. ReactJs is used to developed frontend of an application. For backend I've used MongoDB for database storage, Express and Nodejs is been used to create apis route that connects frontend part of an application with backend and database. Socket.io is been used to setup live chat feature."}
          tech1={"MongoDB"}
          tech3={"NodeJs"}
          tech4={"ReactJs"}
          tech5={"Socket.io"}
        />

        <Project
          title={"3. Mantra Ecommerce Application."}
          text={"Personal Project."}
          image={Mantra}
          link="https://mantracom.netlify.app"
          description={"Mantra, full stack ecommerce web-application that supports token based user authorization in order to place or modify orders. Build in admin pannel for adminstrative purpose in order to add, modify, delete products and to monitor customer orders."}
          tech1={"MongoDB"}
          tech2={"ExpressJs"}
          tech3={"NodeJs"}
          tech4={"ReactJs"}
        />

        <Project
          title={"4. Drim."}
          text={"Personal Project."}
          image={Drim}
          link="https://drim.vercel.app"
          description={"Drim, full stack vehicle booking web application that allows users to book their dream car, track down all their bookings with secure integrated payment system."}
          tech1={"MongoDB"}
          tech2={"ExpressJs"}
          tech3={"NodeJs"}
          tech4={"ReactJs"}
        />

        <Project
          title={"5. Google Meet Clone."}
          text={"Personal Project."}
          image={GoogleMeet}
          link="https://googlemeetclone.herokuapp.com"
          description={"Allows user to setup workspace and interact over video and chat."}
          tech1={"NodeJs"}
          tech2={"Socket.io"}
        />

      </div>
    </div>
  );
};

export default Projects;
